module.exports = __webpack_public_path__ + "static/humanitarian_card_img2@2x-43347bf4da27ba00c833870767062f44.jpg";